import styled, { css } from 'styled-components';
import {JACKPOTS_ITEM} from '../../../../themes/css-global-classes';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';


interface SwiperGamesListBoxProp {
    isTouchDevice: boolean;
}

const DefaultBox = styled.div<SwiperGamesListBoxProp>`
    position: relative;
    display: flex;
    justify-content: flex-start;
    transition: transform .5s ease-in-out;
    will-change: transform;
    width: 100%;
    height: 100%;
    margin-top: 10px;

    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
        display: none;
    }

    ${({isTouchDevice}) => !isTouchDevice? css`
        overflow: visible;
    ` : css`
        overflow-x: scroll;
        overflow-y: hidden;
    `}
`;

const PcBox = styled(DefaultBox)`
`;

const MobileBox = styled(DefaultBox)`
    margin-top: 5px;
    margin-bottom: 20px;

    .${JACKPOTS_ITEM} & {
        display: flex;
        flex-wrap: wrap;
        @media ${({theme}) => theme.mediaQuery.sAndBelow} {
            flex-direction: column;
        }

        @media ${({theme}) => theme.mediaQuery.mAndAbove} {
            flex-direction: row;
        }
    }
`;

export const SwiperGamesListDefaultBox = styledByDevice(PcBox, MobileBox);
